export enum SignUpEntryLandingEnum {
  Remortgage,
  BuyProperty,
  TrackMortgage,
}
